import * as Types from './mutation-types'
import {
  API_STATES
} from '@/helpers'

const mutations = {

  [Types.GET_MODULES_REQUEST](state) {
    state.modulesGetState = API_STATES.REQUEST_PENDING
  },
  [Types.GET_MODULES_SUCCESS](state, modules) {
    state.modulesGetError = null
    state.modules = modules
    state.modulesGetState = API_STATES.REQUEST_SUCCESS
  },
  [Types.GET_MODULES_ERROR](state, err) {
    state.modulesGetState = API_STATES.REQUEST_ERROR
    state.modulesGetError = err
  },
  [Types.UPDATE_MODULES_REQUEST](state) {
    state.modulesUpdateState = API_STATES.REQUEST_PENDING
  },
  [Types.UPDATE_MODULES_SUCCESS](state, data) {
    state.modulesUpdateState = API_STATES.REQUEST_SUCCESS
    state.modules = state.modules.map(module => module.id === data.id ? data :
      module)
    state.modulesUpdateError = null
  },
  [Types.UPDATE_MODULES_ERROR](state, err) {
    state.modulesUpdateState = API_STATES.REQUEST_ERROR
    state.modulesUpdateError = err
  },



}

export default mutations
